// extracted by mini-css-extract-plugin
export default {"toolpanel-button":"ToolPanelButton_toolpanel-button__ksdnI","x-btn-disabled":"ToolPanelButton_x-btn-disabled__UvMjr","x-btn-pressed":"ToolPanelButton_x-btn-pressed__qBoYS"};